(() => {
  const initialize = (section) => {
    if (section.dataset.phReady === 'true') return;

    const viewport = section.querySelector('[data-ph-review-viewport]');
    const track = section.querySelector('[data-ph-review-track]');
    const firstGroup = section.querySelector('[data-ph-review-group]');
    if (!viewport || !track || !firstGroup) return;

    section.dataset.phReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = Math.max(0, Number(section.dataset.speed) || 14);
    let offset = 0;
    let lastTime = performance.now();
    let paused = reduceMotion;
    let dragging = false;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let draggedDistance = 0;
    let hovering = false;
    let resumeTimer;
    let animationFrame = 0;
    let isNearViewport = false;
    let visibilityObserver;

    const loopWidth = () => firstGroup.getBoundingClientRect().width;

    const normalize = () => {
      const width = loopWidth();
      if (!width) return;
      offset = ((offset % width) + width) % width;
    };

    const draw = () => {
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    };

    const frame = (time) => {
      if (!isNearViewport) {
        animationFrame = 0;
        return;
      }

      const elapsed = Math.min((time - lastTime) / 1000, .1);
      lastTime = time;
      if (!paused && !dragging) {
        offset += speed * elapsed;
        normalize();
        draw();
      }
      animationFrame = requestAnimationFrame(frame);
    };

    const startAnimation = () => {
      if (animationFrame) return;
      lastTime = performance.now();
      animationFrame = requestAnimationFrame(frame);
    };

    const pause = () => {
      window.clearTimeout(resumeTimer);
      paused = true;
    };

    const resume = (delay = 0) => {
      if (reduceMotion) return;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
        lastTime = performance.now();
      }, delay);
    };

    viewport.addEventListener('mouseenter', () => {
      hovering = true;
      pause();
    });
    viewport.addEventListener('mouseleave', () => {
      hovering = false;
      if (!dragging) resume(250);
    });

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      pause();
      dragStartX = event.clientX;
      dragStartOffset = offset;
      draggedDistance = 0;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      draggedDistance = event.clientX - dragStartX;
      offset = dragStartOffset - draggedDistance;
      normalize();
      draw();
      if (Math.abs(draggedDistance) > 8) event.preventDefault();
    });

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      if (!hovering) resume(900);
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', () => {
      normalize();
      draw();
    }, { passive: true });

    draw();
    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver((entries) => {
        isNearViewport = entries[0].isIntersecting;
        if (isNearViewport) startAnimation();
      }, { rootMargin: '300px 0px' });
      visibilityObserver.observe(section);
    } else {
      isNearViewport = true;
      startAnimation();
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;
      if (animationFrame) cancelAnimationFrame(animationFrame);
      visibilityObserver?.disconnect();
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ph-review-marquee]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
